import { apiCall } from "../../services/api-service";

export const getVehiclesListApi = async (params) => {
  try {
    const response = await apiCall("GET", "vehicle", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const submitVehicleAPI = async (body) => {
  try {
    const response = await apiCall("POST", "vehicle", body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const updateVehicleAPI = async (id, body) => {
  try {
    const response = await apiCall("PUT", `vehicle/${id}`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const getVehicleEditApi = async (id) => {
  try {
    const response = await apiCall("GET", `vehicle/get/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const deleteVehicleApi = async (id) => {
  try {
    const response = await apiCall("DELETE", `vehicle/delete/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const bulkDeleteVehicleApi = async (payload) => {
  try {
    const data = Array.isArray(payload) ? { id: payload } : payload;
    const response = await apiCall("DELETE", "vehicle/bulkdelete", data);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const saveAttachmentApi = async (id, body) => {
  try {
    const response = await apiCall("PUT", `vehicle/attachment/${id}`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const submitVehicleFuelEntry = async (body) => {
  try {
    const response = await apiCall("POST", `vehicle/fuel_entry`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const submitVehicleKMEntry = async (body) => {
  try {
    const response = await apiCall("POST", `vehicle/km_entry`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
export const getVehicleViewApi = async (id) => {
  try {
    const response = await apiCall("GET", `vehicle/get/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};

export const updateStatusApi = async (id, bodyData) => {
  try {
    const response = await apiCall("PUT", `vehicle/status_update/${id}`, bodyData);
    console.log("response..", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching category:", err);
    return err.response?.data ?? { success: false, message: err.message };
  } finally {
  }
};

export const getFuelEntryApi = async (id, params) => {
  try {
    const response = await apiCall("GET", `vehicle/fuel_entry/${id}`, null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
export const getKMEntryApi = async (id, params) => {
  try {
    const response = await apiCall("GET", `vehicle/km_entry/${id}`, null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);
  } finally {
  }
};
 
export const saveFuelAttachmentApi = async (id, body) => {
  try {
    const response = await apiCall("PUT", `vehicle/fuel_entry/attachment/${id}`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

export const saveKMAttachmentApi = async (id, body) => {
  try {
    const response = await apiCall("PUT", `vehicle/km_entry/attachment/${id}`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching category:", err);

    // Return server error data if available, else generic error
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
